'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notice = require('./notice.js');

var _notice2 = _interopRequireDefault(_notice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _notice2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-notice/lib/index.js
// module id = 438
// module chunks = 0